import { useCallback } from 'react';
import { useAuthStore } from '@/stores/authStore';
import type { PersonaId } from '@/types';

export function usePersona() {
  const currentPersona = useAuthStore((s) => s.currentPersona);
  const setCurrentPersona = useAuthStore((s) => s.setCurrentPersona);
  const setActiveConversation = useAuthStore((s) => s.setActiveConversation);
  const conversations = useAuthStore((s) => s.conversations);

  const switchPersona = useCallback(
    (persona: PersonaId) => {
      setCurrentPersona(persona);
      // Try to find an existing conversation for this persona
      const existingConv = conversations.find((c) => c.persona === persona);
      setActiveConversation(existingConv?.id || null);
    },
    [setCurrentPersona, setActiveConversation, conversations]
  );

  return {
    currentPersona,
    switchPersona,
  };
}
